import { render, staticRenderFns } from "./NotFount.vue?vue&type=template&id=9d077f1e&scoped=true"
import script from "./NotFount.vue?vue&type=script&lang=js"
export * from "./NotFount.vue?vue&type=script&lang=js"
import style0 from "./NotFount.vue?vue&type=style&index=0&id=9d077f1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d077f1e",
  null
  
)

export default component.exports